import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {}
        }
    },
    getters: {
        items: state => state.items
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('admin/providers', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('admin/providers', payload);

            return response;
        },
        async update({ commit }, payload) {
            const response = await http.patch(`admin/providers/${payload.id}`, payload);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`admin/providers/${id}`);

            return response;
        }
    }
}